<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('account.manage') }}
      </div>
    </div>
    <div class="wrap_box warp1">
      <p><span>{{ allNum }}</span> {{ $t('account.withdrawalAccounts') }}</p>
    </div>
    <div
      v-if="empty"
      class="wrap_box warp2"
    >
      <van-empty :description="$t('orders.noOrders')" />
    </div>
    <div
      v-else
      class="wrap_box warp2"
    >
      <div
        v-for="i in data.bank"
        :key="i.id"
        class="item"
      >
        <img
          :src="require('../images/user/recharge'+i.type+'.png')"
          alt=""
        >
        <div class="item_detail">
          <p class="user_name ari_font">
            {{ i.bank }}
          </p>
          <p class="user_num">
            {{ i.account }}
          </p>
          <p
            v-if="i.cci"
            class="user_num"
          >
            {{ $t('invest_bank.cci') }}: {{ i.cci }}
          </p>
        </div>
        <div
          class="del"
          @click="delCard(i.id)"
        />
      </div>
    </div>
    <div
      class="basic_btn"
      @click="$router.push('/addcountUsdt')"
    >
      {{ $t('account.add') }}
    </div>
  </div>
</template>

<script>
    import Vue from 'vue'
    import Fetch from '../../utils/fetch'
    import { Empty } from 'vant'

    Vue.use(Empty)


    export default {
        name: "Account",
        data() {
            return {
                allNum:0,
                data: { bank: [] },
                empty: false
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
            delCard(id){
                Fetch('/user/bank_remove', {id: id}).then(() => {
                    this.start()
                });
            },
            start(){
                Fetch('/user/my_bank', {}, { method: 'get' }).then(r=>{
                    this.data = r.data;
                    this.allNum = r.data.count;
					this.empty = !Array.isArray(r.data.bank) || r.data.bank.length === 0;
                })
            }
        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg {
        position: relative;
    }
	

    .warp1 {
        padding: 0 20px;
        height: 40px;

        p {
            font-size: 14px;
            line-height: 40px;
            color: rgba(0,0,0,.8);
            font-weight: bold;

            span {
                color: #F03041;
            }
        }
    }

    .ari_font {
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,.8);
        line-height: 20px;
    }

    .warp2 {
        padding: 0 15px;
        margin-top: 12px;

        .item {
            padding: 14px 0 11px 0;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border-bottom: 1px solid #ECECEC;

            &:last-child {
                border-bottom: none;
            }

            img {
                width: 30px;
                height: 30px;
            }

            .item_name {
                width: 65px;
            }
			.item_detail{
				margin-left: 10px;
			}

            .user_num {
                min-height: 17px;
                font-size: 12px;
                line-height: 17px;
                word-break: break-all;
                font-weight: 600;
                color: rgba(0,0,0,.6);
                line-height: 17px;
                margin-top: 10px;
            }

            .del {
                width: 20px;
                height: 20px;
                background: url(../images/item/del.png) no-repeat center center;
                background-size: 100% 100%;
                margin: 0 8px 0 auto;
            }
        }
    }

    .basic_btn {
        margin: 50px auto 0 auto;
    }

    .recharge_wrap { min-height: 100vh; background: #f5f5f5; padding-bottom: calc(var(--app-bottom-menu-height) + 28px + env(safe-area-inset-bottom, 0px)); }
    .red_top_bg { height: 50px; background: #fff; border-bottom: 1px solid #eee; }
    .back_left { filter: brightness(0); opacity: 1; }
    .big_tit { top: 13px; color: #333; font-size: 16px; font-weight: 500; }
    .wrap_box { background: #fff; }
    .warp1 { margin: 10px 0 0; padding: 0 16px; height: 46px; border-bottom: 1px solid #eee; }
    .warp1 p { line-height: 46px; color: #555; font-size: 13px; }
    .warp1 p span { color: #ee4d2d; }
    .warp2 { margin-top: 0; padding: 0 16px; }
    .warp2 .item { min-height: 66px; padding: 12px 0; }
    .basic_btn { width: calc(100% - 32px); height: 42px; margin: 24px auto 0; border-radius: 4px; background: #ee4d2d; color: #fff; line-height: 42px; }
</style>
